<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import useAppStore from '@/stores/useAppStore';

const i18n = useI18n();
const route = useRoute();
const appStore = useAppStore();

watch(
  route,
  () => {
    document.title = i18n.t('title.prefix') + i18n.t(route.meta.title || 'title.default');
  },
  { immediate: true }
);
</script>
<template>
  <router-view />
</template>
